/**
 * @generated SignedSource<<c0b0a81f1ad5ca80ad60929760200e96>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProjectActivateMutation$variables = {
  id: number;
};
export type ProjectActivateMutation$data = {
  readonly activateProject: {
    readonly project: {
      readonly active: boolean;
      readonly id: number;
    } | null | undefined;
  };
};
export type ProjectActivateMutation = {
  response: ProjectActivateMutation$data;
  variables: ProjectActivateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ProjectResult",
    "kind": "LinkedField",
    "name": "activateProject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "projects",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectActivateMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectActivateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a751777b79b75778725152fae0817802",
    "id": null,
    "metadata": {},
    "name": "ProjectActivateMutation",
    "operationKind": "mutation",
    "text": "mutation ProjectActivateMutation(\n  $id: Int!\n) {\n  activateProject(id: $id) {\n    project {\n      id\n      active\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f57290f4b212938e224f6421740d4b74";

export default node;
